export default __webpack_public_path__ + "static/media/TrendDown.28a9d6e1.svg";